var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderRow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3333 6.66667L4.66667 6.66667C4.29867 6.66667 4 6.368 4 6V4.66667C4 4.29867 4.29867 4 4.66667 4L15.3333 4C15.7013 4 16 4.29867 16 4.66667V6C16 6.368 15.7013 6.66667 15.3333 6.66667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66667 11.3332H4.33333C4.14933 11.3332 4 11.0345 4 10.6665V9.33317C4 8.96517 4.14933 8.6665 4.33333 8.6665L9.66667 8.6665C9.85067 8.6665 10 8.96517 10 9.33317V10.6665C10 11.0345 9.85067 11.3332 9.66667 11.3332Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3333 16.0002H4.66667C4.29867 16.0002 4 15.7015 4 15.3335V14.0002C4 13.6322 4.29867 13.3335 4.66667 13.3335L15.3333 13.3335C15.7013 13.3335 16 13.6322 16 14.0002V15.3335C16 15.7015 15.7013 16.0002 15.3333 16.0002Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderRow);
export default ForwardRef;